import type { Niva } from "@batkoll/gemensam";
import type { ComponentChildren } from "preact";

export function Kort(props: {
  rubrik: string;
  children: ComponentChildren;
  ton?: "varning" | "akut";
  bred?: boolean;
}) {
  const klass = ["kort", props.ton ? `kort-${props.ton}` : "", props.bred ? "kort-bred" : ""]
    .filter(Boolean)
    .join(" ");
  return (
    <section class={klass} aria-label={props.rubrik}>
      <h2>{props.rubrik}</h2>
      {props.children}
    </section>
  );
}

export function Rad(props: { namn: string; children: ComponentChildren; gammalt?: boolean }) {
  return (
    <div class={`rad${props.gammalt ? " gammalt" : ""}`}>
      <span class="namn">{props.namn}</span>
      <span class="varde">{props.children}</span>
    </div>
  );
}

/** En stapel för laddningen. */
export function Matare(props: { procent: number | undefined; etikett: string }) {
  const p = props.procent;
  const niva = p === undefined ? "" : p < 20 ? "lag" : p < 50 ? "mellan" : "hog";
  return (
    <div class="matare">
      <div class="matare-spar" aria-hidden="true" title={props.etikett}>
        <div
          class={`matare-fyll ${niva}`}
          style={{ width: `${Math.max(0, Math.min(100, p ?? 0))}%` }}
        />
      </div>
    </div>
  );
}

const NIVATEXT: Record<Niva, string> = { info: "Info", varning: "Varning", akut: "Akut" };

export function Nivamarke(props: { niva: Niva }) {
  return <span class={`niva niva-${props.niva}`}>{NIVATEXT[props.niva]}</span>;
}
